import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberRelationshipStatus } from '../../../../models/users/dto/member-relationship-status';
import { ReviewEntryComponent } from '../../../../ui/review-components/review-entry/review-entry.component';
import { RelationshipEffectiveDateReviewEntryComponent } from '../../../../ui/review-components/relationship-effective-date-review-entry/relationship-effective-date-review-entry.component';
import { CommonModule } from '@angular/common';
import { RelationshipStatusIsPartneredForDisplayPipe } from '../../../../pipes/relationship-status-is-partnered-for-display.pipe';

@Component({
  selector: 'app-confirm-relationship-status-grid',
  templateUrl: './confirm-relationship-status-grid.component.html',
  styleUrls: ['./confirm-relationship-status-grid.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReviewEntryComponent,
    RelationshipEffectiveDateReviewEntryComponent,
    RelationshipStatusIsPartneredForDisplayPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmRelationshipStatusGridComponent {
  @Input() relationshipStatus!: MemberRelationshipStatus;
}
